import omitProps from '@hocs/omit-props';
import { compose, setDisplayName, withProps } from 'recompose';
import { ExperimentSpec } from '../../../constants/ExperimentSpec';
import { withExperiments } from '../withExperiments';

export const withExperimentsSettings = compose(
  setDisplayName('withExperimentsSettings'),
  withExperiments,
  withProps(({ experiments }) => ({
    _experimentsSettings: {
      isEmailWithWixDomain: experiments.enabled(ExperimentSpec.PublicMediaWixOnly),
      isCantBuyOnShutterstockExperimentEnabled: experiments.enabled(ExperimentSpec.CantBuyOnShutterstock),
      isNewCheckoutExperimentEnabled: experiments.enabled(ExperimentSpec.NewCheckout),
      isNTTExperimentEnabled: experiments.enabled(ExperimentSpec.NTT),
      isShowKeysExperimentEnabled: experiments.enabled(ExperimentSpec.ShowKeys),
      isOnlyFavsBoardExperimentEnabled: experiments.enabled(ExperimentSpec.OnlyFavsBoard),
      isPreventFontsUploadExperimentEnabled: experiments.enabled(ExperimentSpec.PreventFontsUpload),
      forceUploadErrorsExperimentValue: experiments.get(ExperimentSpec.ForceUploadErrors),
      isDisableUploadExperimentEnabled: experiments.enabled(ExperimentSpec.DisableUpload),
      isSemanticSearchExperimentEnabled: experiments.enabled(ExperimentSpec.SemanticSearch),
      isLinkToPublicCMSExperimentEnabled: experiments.enabled(ExperimentSpec.LinkToPublicCMS),
      isPriceWithTaxExperimentEnabled: experiments.enabled(ExperimentSpec.PriceWithTax),
      isHideShareFromAgenciesExperimentEnabled: experiments.enabled(ExperimentSpec.HideShareFromAgencies),
      isYellExperimentEnabled: experiments.enabled(ExperimentSpec.Yell),
      isForceYellExperimentEnabled: experiments.enabled(ExperimentSpec.ForceYell),
      isUploadUpgradeLinkExperimentEnabled: experiments.enabled(ExperimentSpec.UploadUpgradeLink),
      isWSRNewColorsBrandingEnabled: experiments.enabled(ExperimentSpec.WSRNewColorsBranding),
      isAITextToImageEnabled: experiments.enabled(ExperimentSpec.AiTextToImage),
      storageQuotaVisibilityAndEnforcementExperiment: experiments.get(
        ExperimentSpec.StorageQuotaVisibilityAndEnforcement,
      ),
      isManageStorageButtonEnabled: experiments.enabled(ExperimentSpec.ManageStorageButton),
    },
  })),
);

export const withoutExperimentsSettings = omitProps('_experimentsSettings');
